/* ==========================================================================
   ZWANZE — slideshow.js
   Diaporama de la page d'accueil.

   Le defilement lui-meme est natif : c'est le navigateur qui fait glisser,
   avec scroll-snap. Ce fichier n'ajoute que trois choses — les fleches,
   la synchronisation des pastilles, et l'avance automatique.

   L'avance automatique s'arrete des que le visiteur montre qu'il regarde :
   survol, doigt sur l'ecran, navigation au clavier, ou onglet en arriere-plan.
   Un diaporama qui continue de defiler pendant qu'on lit est une nuisance.
   Elle ne demarre pas du tout si le visiteur a demande moins d'animations.
   ========================================================================== */
(function () {
  'use strict';

  function motionOff() {
    var level = getComputedStyle(document.documentElement).getPropertyValue('--z-motion').trim();
    return level === '0' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class Slideshow extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.z-slides__viewport');
      this.slides = Array.from(this.querySelectorAll('.z-slides__slide'));
      this.dots = Array.from(this.querySelectorAll('.z-slides__dot'));
      if (!this.viewport || this.slides.length < 2) return;

      this.index = 0;
      this.paused = false;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.go)));
      });
      var prev = this.querySelector('[data-slide-prev]');
      var next = this.querySelector('[data-slide-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

      // Fleches du clavier quand le diaporama a le focus
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      });

      this.observer = new IntersectionObserver(this._onIntersect.bind(this), {
        root: this.viewport,
        threshold: 0.55
      });
      this.slides.forEach((slide) => this.observer.observe(slide));

      var seconds = parseFloat(this.dataset.auto || '0');
      if (seconds > 0 && !motionOff()) {
        ['pointerenter', 'focusin', 'pointerdown'].forEach((evt) =>
          this.addEventListener(evt, () => { this.paused = true; }));
        ['pointerleave', 'focusout'].forEach((evt) =>
          this.addEventListener(evt, () => { this.paused = false; }));
        document.addEventListener('visibilitychange', () => { this.paused = document.hidden; });
        this.timer = window.setInterval(() => {
          if (!this.paused) this.goTo(this.index + 1);
        }, seconds * 1000);
      }
    }

    goTo(i) {
      var target = this.slides[(i + this.slides.length) % this.slides.length];
      if (!target) return;
      // scrollIntoView ferait aussi remonter la page entiere sur certains
      // navigateurs : on deplace uniquement le defilement horizontal.
      this.viewport.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    _onIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        this.index = this.slides.indexOf(entry.target);
        var i = this.index;
        this.dots.forEach(function (dot) {
          dot.setAttribute('aria-selected', Number(dot.dataset.go) === i ? 'true' : 'false');
        });
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.timer) window.clearInterval(this.timer);
    }
  }

  if (!customElements.get('z-slideshow')) customElements.define('z-slideshow', Slideshow);
})();
